
//#region src/plugins/container/runtimePlugin.ts
function runtimePlugin_default() {
	return {
		name: "next-internal-plugin",
		createScript: function(args) {
			const url = args.url;
			const attrs = args.attrs;
			if (typeof window !== "undefined") {
				const script = document.createElement("script");
				script.src = url;
				script.async = true;
				delete attrs?.["crossorigin"];
				return {
					script,
					timeout: 8e3
				};
			}
		},
		errorLoadRemote: function(args) {
			const id = args.id;
			const error = args.error;
			const from = args.from;
			globalThis.moduleGraphDirty = true;
			console.error(id, "offline");
			const pg = function() {
				console.error(id, "offline", error);
				return null;
			};
			pg.getInitialProps = function(ctx) {
				return {};
			};
			let mod;
			if (from === "build") mod = function() {
				return {
					__esModule: true,
					default: pg,
					getServerSideProps: function() {
						return { props: {} };
					}
				};
			};
			else mod = {
				default: pg,
				getServerSideProps: function() {
					return { props: {} };
				}
			};
			return mod;
		},
		beforeInit: function(args) {
			if (!globalThis.usedChunks) globalThis.usedChunks = /* @__PURE__ */ new Set();
			if (typeof __webpack_runtime_id__ === "string" && !__webpack_runtime_id__.startsWith("webpack")) return args;
			const moduleCache = args.origin.moduleCache;
			const name = args.origin.name;
			let gs;
			try {
				gs = new Function("return globalThis")();
			} catch (e) {
				gs = globalThis;
			}
			const attachedRemote = gs[name];
			if (attachedRemote) moduleCache.set(name, attachedRemote);
			return args;
		},
		init: function(args) {
			return args;
		},
		beforeRequest: function(args) {
			const options = args.options;
			const remoteName = args.id.split("/").shift();
			const remote = options.remotes.find(function(remote) {
				return remote.name === remoteName;
			});
			if (!remote) return args;
			if (remote && remote.entry && remote.entry.includes("?t=")) return args;
			remote.entry = remote.entry + "?t=" + Date.now();
			return args;
		},
		afterResolve: function(args) {
			return args;
		},
		onLoad: function(args) {
			const exposeModuleFactory = args.exposeModuleFactory;
			const exposeModule = args.exposeModule;
			const id = args.id;
			const moduleOrFactory = exposeModuleFactory || exposeModule;
			if (!moduleOrFactory) return args;
			if (typeof window === "undefined") {
				let exposedModuleExports;
				try {
					exposedModuleExports = moduleOrFactory();
				} catch (e) {
					exposedModuleExports = moduleOrFactory;
				}
				const handler = { get: function(target, prop, receiver) {
					if (target === exposedModuleExports && typeof exposedModuleExports[prop] === "function") return function() {
						globalThis.usedChunks.add(id);
						return exposedModuleExports[prop].apply(this, arguments);
					};
					const originalMethod = target[prop];
					if (typeof originalMethod === "function") {
						const proxiedFunction = function() {
							globalThis.usedChunks.add(id);
							return originalMethod.apply(this, arguments);
						};
						Object.keys(originalMethod).forEach(function(prop) {
							Object.defineProperty(proxiedFunction, prop, {
								value: originalMethod[prop],
								writable: true,
								enumerable: true,
								configurable: true
							});
						});
						return proxiedFunction;
					}
					return Reflect.get(target, prop, receiver);
				} };
				if (typeof exposedModuleExports === "function") {
					exposedModuleExports = new Proxy(exposedModuleExports, handler);
					Object.getOwnPropertyNames(exposedModuleExports).forEach(function(prop) {
						if (typeof exposedModuleExports[prop] === "function") exposedModuleExports[prop] = new Proxy(exposedModuleExports[prop], handler);
					});
					return function() {
						return exposedModuleExports;
					};
				} else exposedModuleExports = new Proxy(exposedModuleExports, handler);
				return exposedModuleExports;
			}
			return args;
		},
		loadRemoteSnapshot(args) {
			const { from, remoteSnapshot, manifestUrl, manifestJson, options } = args;
			if (from !== "manifest" || !manifestUrl || !manifestJson || !("publicPath" in remoteSnapshot)) return args;
			const { publicPath } = remoteSnapshot;
			if (options.inBrowser && publicPath.includes("/_next/")) remoteSnapshot.publicPath = publicPath.substring(0, publicPath.lastIndexOf("/_next/") + 7);
			else remoteSnapshot.publicPath = manifestUrl.substring(0, manifestUrl.indexOf("mf-manifest.json"));
			if ("publicPath" in manifestJson.metaData) manifestJson.metaData.publicPath = remoteSnapshot.publicPath;
			return args;
		},
		resolveShare: function(args) {
			if (args.pkgName !== "react" && args.pkgName !== "react-dom" && !args.pkgName.startsWith("next/")) return args;
			const shareScopeMap = args.shareScopeMap;
			const scope = args.scope;
			const pkgName = args.pkgName;
			const version = args.version;
			const host = args.GlobalFederation["__INSTANCES__"][0];
			if (!host) return args;
			if (!host.options.shared[pkgName]) return args;
			args.resolver = function() {
				shareScopeMap[scope][pkgName][version] = host.options.shared[pkgName][0];
				return {
					shared: shareScopeMap[scope][pkgName][version],
					useTreesShaking: false
				};
			};
			return args;
		},
		beforeLoadShare: async function(args) {
			return args;
		}
	};
}

//#endregion
module.exports = runtimePlugin_default;
//# sourceMappingURL=runtimePlugin.js.map